import { useTheme } from "next-themes";
import NextImage from "next/image";
import { ImageProps as NextImageProps } from "next/image";

interface ImageProps extends Record<"lightIcon" | "darkIcon", string>, Omit<NextImageProps, "src"> {}

export function Image({ darkIcon, lightIcon, ...props }: ImageProps) {
  const { theme } = useTheme();
  return (
    <NextImage
      style={{
        maxWidth: "none",
      }}
      {...props}
      src={theme === "light" ? lightIcon : darkIcon}
    />
  );
}
